export default class InvalidStatsError extends Error {
	name = 'InvalidStatsError';
}
